import * as React from 'react';

import { mapStringToOptions } from 'src/modulos/Matriculas/IngresoNuevaMatricula/utils/mapStringToOptions';
import SeleccionableOtro, {
    Datos as SeleccionableOtroDatos,
    inicial as seleccionableOtrosInicial,
} from '../SeleccionableOtro';

const relacionesConAlumno = [
    'Padre',
    'Madre',
    'Hermano(a)',
    'Tío(a)',
    'Abuelo(a)',
    'Pareja',
    'Amigo(a)',
    'Otro',
];

export interface Datos extends SeleccionableOtroDatos {}

export const inicial: Datos = {
    ...seleccionableOtrosInicial,
};

const relacionConAlumnoOptions = mapStringToOptions(relacionesConAlumno);

interface Props {
    mostrar?: boolean;
    relacionConAlumno: Datos;
    onChange(relacionConAlumno: Datos): void;
}

const RelacionConAlumno: React.FunctionComponent<Props> = props => {
    const { mostrar = true, relacionConAlumno, onChange } = props;

    return (
        <SeleccionableOtro
            select={{
                etiqueta: 'Relación/parentesco con el alumno',
                opciones: relacionConAlumnoOptions,
                requerido: mostrar,
            }}
            input={{
                etiqueta: 'Especifique',
                mostrar: () => mostrar && relacionConAlumno.id === 'Otro',
            }}
            valor={relacionConAlumno}
            onChange={value => {
                onChange({ ...value });
            }}
        />
    );
};

export default RelacionConAlumno;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/RelacionConAlumno/index.tsx